var React = require('react');

function ListFilter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 6H21M7 12H17M10 18H14","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ListFilter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ListFilter;

ListFilter.default = ListFilter;
